export default "__VITE_ASSET__0A4rjjoZ__"